import { render, staticRenderFns } from "./echarts.vue?vue&type=template&id=5283fe7a&scoped=true"
import script from "./echarts.vue?vue&type=script&lang=js"
export * from "./echarts.vue?vue&type=script&lang=js"
import style0 from "./echarts.vue?vue&type=style&index=0&id=5283fe7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5283fe7a",
  null
  
)

export default component.exports